// Copyright ©️ 2026 eVolve MEP, LLC

import type { HexTriplet } from '@evolvemep/api-ts';

import checkmarkSvg from 'assets/icons/icon-src/markup/checkmark.svg?raw';
import type { MarkupToolContext } from 'components/Autodesk/extensions/MarkupModeExtension/BaseMarkupTool';
import { makeStampConfig, type StampConfig } from 'components/Autodesk/extensions/MarkupModeExtension/StampMarkup';
import { CHECKMARK_PATH_TOKENS } from 'components/Autodesk/extensions/MarkupModeExtension/stampPathTokens/checkmarkPathTokens';
import { StampTool } from 'components/Autodesk/extensions/MarkupModeExtension/StampTool';

export const CHECKMARK_CONFIG: StampConfig = makeStampConfig('checkmark', 'CHECKMARK', CHECKMARK_PATH_TOKENS);

export class CheckmarkTool extends StampTool {
  constructor(context: MarkupToolContext) {
    super(context, {
      type: 'checkmark',
      label: 'Checkmark',
      iconSvg: checkmarkSvg,
      stampConfig: CHECKMARK_CONFIG,
      defaults: {
        fillColor: '#00AA00' as HexTriplet, // Green color.
        stampSize: 24,
      },
    });
  }
}
